import * as types from './types';
import { loading, error } from 'State/actions';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';

export const getExportFileType = fileTypes => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GENERIC_EXPORT_SET_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('Export/ExportFileType');

      dispatch({
        type: types.GENERIC_EXPORT_GET_EXPORTFILETYPE,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.GENERIC_EXPORT_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.GENERIC_EXPORT_SET_LOADING, false));
  };
};

export const getExportFile = (model, filename) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GENERIC_EXPORT_SET_SUBMITTING, true));

    try {
      const response = await MPWWebApi.postDownloadFile(
        `Export/Generic`,
        filename,
        model,
        FileDownloadTypes.Txt
      );

      dispatch({
        payload: response,
        type: types.GENERIC_EXPORT_GET_FILE,
      });
    } catch (e) {
      dispatch(error(types.GENERIC_EXPORT_ERROR, e));
    }
    dispatch(loading(types.GENERIC_EXPORT_SET_SUBMITTING, false));
  };
};

export const clearErrors = () => {
  return {
    type: types.GENERIC_EXPORT_CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/genericexport/state/monthlyexport/actions.js